<script lang="ts">
  import data from "../../../../Data/Ecommerce/Ecommerce.json";
  import RangeSlider from "svelte-range-slider-pips";
  import { Image } from "sveltestrap";
  import Carousel from "svelte-carousel";
  import { NewProducts } from "../../../../utils/Constant/Constant";
  import { selectValue } from "../../../../store";
  let imgPath: string = "/assets/images/ecommerce";
  let values = [30];
  let carousel: any;
  $: selectValue.update((value) => (value = values[0]));
</script>

<div class="product-filter pb-0">
  <h6 class="f-w-600">Price</h6>
  <RangeSlider
    range
    bind:values
    min={0}
    max={500}
    all="label"
    pipstep={50}
    pips
  />
  <h6 class="f-w-600">{NewProducts}</h6>
</div>
<div class="product-filter pb-0 new-products">
    <div class="owl-carousel owl-theme" id="testimonial">
        <Carousel
        bind:this={carousel}
        particlesToShow={1}
        particlesToScroll={1}
        arrows={true}
        dots={false}
        >
        <div class="item">
        {#each data.newproductdata as productItem}
          {#each productItem.first as item}
            <div class="product-box">
              <div class="media">
                <div class="product-img me-3">
                  <Image fluid class="img-100" src="{imgPath}/{item.img}" alt="product"/>
                </div>
                <div class="media-body">
                  <div class="product-details">
                    <p class="mb-0">{item.title}</p>
                    <div class="f-w-500">{item.price}</div>
                  </div>
                </div>
              </div>
            </div>
          {/each}
        {/each}
        </div>
      </Carousel>
    </div>
</div>
<div class="product-filter text-center">
  <Image fluid class="banner-product" src="{imgPath}/banner.jpg" />
</div>
